module.exports = __webpack_public_path__ + "img/process-support.8ca9d4cd.png";